module.exports = __webpack_public_path__ + "img/daece8f.png";